import { Component } from '@angular/core';
import { AuthUserService } from '../../services/auth-user.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ApprovedFormsListComponent } from '../../components/approved-forms-list/approved-forms-list.component';

@Component({
  selector: 'app-approved-review-forms',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ApprovedFormsListComponent
  ],
  templateUrl: './approved-forms.component.html',
  styleUrl: './approved-forms.component.scss'
})
export class ApprovedFormsComponent {

  constructor(public authUserService: AuthUserService) {
  }
}
